import api, { ValidateAxiosError, } from '@/modules/api.service';
import { CreateDistritoDto, ReadDistritoDto, UpdateDistritoDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindDistritoDto } from '@/api.types.extra';

const endpoint = Endpoints.DISTRITO;

export async function createDistrito(dto: CreateDistritoDto): Promise<string> {
  try {
    const response = await api.post(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar o distrito.');
  }
}

export async function readDistrito(filters: FindDistritoDto): Promise<[ReadDistritoDto[], number]> {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar distrito(s).');
  }
}

export async function readDistritoPublic(filters: FindDistritoDto): Promise<[ReadDistritoDto[], number]> {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get(endpoint + '/public', { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar distrito(s).');
  }
}

export async function updateDistrito(dto: UpdateDistritoDto): Promise<string> {
  try {
    const response = await api.put(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar o distrito.');
  }
}

export async function deleteDistrito(id: number) {
  return api
    .delete(endpoint + '/' + id)
    .then(() => {
      return 'Distrito removido.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover Distrito.');
    });
}